import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import useSessionStorageProject from './useSessionStorageProject';

export default function SetProjectSourceIdFromRoute() {
	const params = useParams<{ projectSourceId: string }>();
	const history = useHistory();

	const { setSource: setProject } = useSessionStorageProject();

	React.useEffect(() => {
		if (params.projectSourceId) {
			setProject(params.projectSourceId);
			history.replace('/');
		}
	}, [params.projectSourceId]);
	return null;
}
